/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 12:23:03
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchCustomization } from 'src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/slice';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';

const CloneBtn = (props) => {
  const { disabled } = props;
  const params: any = useParams();
  const { salesChannelProductUuid } = params;
  const _d = useDispatch();
  const handleOnClick = () => {
    _d(
      fetchCustomization({
        //1===true 0===false
        productUuid: salesChannelProductUuid,
        params: {
          [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
        },
        isClone: true,
      }),
    );
  };
  return <Button onClick={handleOnClick} disabled={disabled} />;
};
export default CloneBtn;
